import * as React from 'react';
import { SiteLogo } from '../entities/site-logo';
export var LogoContext = React.createContext(null);
export var LogoProvider = function LogoProvider(_a) {
  var value = _a.value,
      children = _a.children;
  return React.createElement(LogoContext.Provider, {
    value: value || SiteLogo
  }, children);
};